import axios from "src/lib/axios";
import { getParams } from "src/common/api";

export const getSalesByItemCode = async (startDate, endDate) => {
  const params = getParams({
    startDate,
    endDate,
  });
  const { data: response } = await axios.get(
    `/dashboard/seller/sales/itemcode?${params}`,
  );
  return response.data;
};

export const getTotalSalesPerDay = async (itemCode, startDate, endDate) => {
  const params = getParams({
    itemCode,
    startDate,
    endDate,
  });
  const { data: response } = await axios.get(
    `/dashboard/seller/sales/total?${params}`,
  );
  return response.data;
};
